<template>
  <div id="app">
	<header-top @backPop="showPasdPop" ></header-top>
	<keep-alive>
		<router-view v-if="$route.meta.keepAlive" />
	</keep-alive>
	<router-view v-if="!$route.meta.keepAlive" />
	<div v-if="isShowPasdPop" class="query-c">
		<div class="editPasdPop">
			<div class="editPasdPopTitle">
				<i style="visibility: hidden;font-size: 20px;" class="el-icon-close"></i>
				<font color="#29B0EA">修改密码</font>
				<i @click="showPasdPop(false)" style="font-size: 20px;cursor: pointer;" class="el-icon-close"></i>
			</div>
			<div class="form">
				<div>
					<label>原密码：</label>
					<input v-model="oldPwd" type="password" placeholder="请输入旧密码" />
				</div>
				<div>
					<label>新密码：</label>
					<input v-model="newPwd" type="password" placeholder="请输入新密码" />
				</div>
				<div>
					<label>确认密码：</label>
					<input v-model="newPwd2" type="password" placeholder="请确认新密码" />
				</div>
				<div style="display: flex;align-items: center;">
					<i style="color: #FFBF43;font-size: 18px;margin-right: 6px;" class="el-icon-warning"></i>
					<font style="font-size: 14px;" color="#B2BBCD">密码不低于6位，可以包含数字、字母、符号</font>
				</div>
				<div>
					<el-button @click="savePwd()" style="width: 200px;" type="primary" >保存</el-button>
				</div>
			</div>
			
		</div>
	</div>
  </div>
</template>
<script>
	import {logout} from './api/login.js'
	import {updatePwd} from './api/user.js'
	import headerTop from '@/components/headerTop/top.vue'
	export default{
		components:{headerTop},
		data(){
			return{
				oldPwd:'',
				newPwd:'',
				newPwd2:'',
				isShowPasdPop:false
			}
		},
		methods:{
			showPasdPop(status){
				console.log(status) 
				this.isShowPasdPop = status;
			},
			savePwd(){
				if(this.oldPwd == ''){
					 this.$message.error('请输入旧密码!');
					return false;
				}
				if(this.newPwd == ''){
					this.$message.error('请输入新密码!');
					return false;
				}
				if(this.newPwd.length < 6){
					this.$message.error('新密码长度不能小于6位!');
					return false;
				}
				if(this.newPwd != this.newPwd2){
					this.$message.error('输入的确认密码和新密码不一致!');
					return false;
				}
				var params = '?oldPwd='+md5(this.oldPwd) + '&newPwd='+md5(this.newPwd);
				updatePwd(params).then((res)=>{
					if(res.code == 200){
						this.$message.success('修改成功,请重新登录!');
						this.showPasdPop(false);
						logout().then((res)=>{
							  if(res.code == 200){
								 this.$router.push({
									path:'/login'
								 }) 
							  }
						})
					}
				})
			}
		}
	}
</script>
<style>
#app {
  font-family: '微软雅黑';
}
html,body{
	margin: 0;
}
#app{
	width: 100vw;
	height: 100vh;
	background:url('@/assets/bg.png') no-repeat;
	background-size: 100% 100%	;
}
.page{
	height: calc(100vh - 70px);
	padding-top: 70px;
}
.el-message--error{
	z-index: 999999999!important;
}
</style>
<style scoped>
	.query-c{
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background: rgba(0,0,0,0.4);
		z-index: 99999;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.editPasdPop{
		background: #fff;
		width: 600px;
		height: 400px;
		border-radius: 10px;
	}
	.editPasdPopTitle{
		padding: 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.form div{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
	}
	.form div label{
		width: 100px;
		text-align: right;
		color: #033333;
		margin-right: 10px;
	}
	.form div input{
		border: 1px solid #eee;
		padding:10px 10px;
		outline: none;
		width: 220px;
	}
</style>